import PropTypes from 'prop-types';

export const TableDataShape = PropTypes.objectOf(
  PropTypes.shape({
    subText: PropTypes.string,
    value: PropTypes.string,
    type: PropTypes.string,
  })
);
